import React from 'react';
import { ForgotPasswordPage } from '../components/Auth-Designer';

const ForgotPasswordPageWrapper = () => {
  return <ForgotPasswordPage />;
};

export default ForgotPasswordPageWrapper;